import { Button, Modal, ModalContent, ModalTitle, ModalActions, FormHelperText,Typography } from '@deere/fuel-react'
import React ,{useState} from 'react'
import { getSubtierMasterDataByName} from "../../services/survey.service";
import { GRAL_VALIDATION_MSGS} from '../../utils/constants.js'
import {SelectGoldenRecord} from '../../components/SelectGoldenRecord';
import {useUserInfo} from '../../providers/userProvider.js';

export const GoldenRecordModal = ({showModal, setShowModal, labelBtnPrimary, submitFn, labelBtnSecondary,titleModal,subtier}) => {
  const [formValidationErrs, setFormValidationErrs] = useState({});
  const [goldenRecord, setGoldenRecord] = useState(null);
  const userInfo = useUserInfo();
  const createdBy = userInfo? userInfo.userID : '';

  const onClose = () => {
      setShowModal(false)
  }

  const handleSubmit = event => {    
    event.preventDefault();
    
    let tmpFormValidationErrs = null;
    tmpFormValidationErrs = (!goldenRecord) ? {goldenRecordHelperTxt:true} : tmpFormValidationErrs;
    
    if(tmpFormValidationErrs=== null){ 
      setFormValidationErrs({});  
    }else{
      setFormValidationErrs(tmpFormValidationErrs);
      return
    };

    const tmpSubtierMasterSurveySubtier = {
      "subtierId": goldenRecord.value,
      "rawSubtierId": subtier.id,
      "supplierNumber": subtier.supplierNo,
      "tierCode": subtier.tierLevel,
      "commodityCode": subtier.productType,
      "diverseCode": subtier.isDiverseEnterprise,
      "createdBy": createdBy
    }
    onClose();
    submitFn(tmpSubtierMasterSurveySubtier);
  };


  return <Modal
        open={showModal}
        onClose={onClose}
        aria-labelledby="alert-Modal-title"
        aria-describedby="alert-Modal-description"
      >
        <form onSubmit={handleSubmit}>
        <ModalTitle id="alert-Modal-title">{titleModal}</ModalTitle>
          <ModalContent>
              <Typography fontWeight="semibold" gutterBottom size="sm">
                Subtier Master
              </Typography>
              <SelectGoldenRecord loadOptionsFunction={getSubtierMasterDataByName} onChange={setGoldenRecord}/>
              {formValidationErrs.goldenRecordHelperTxt===true && <FormHelperText>{GRAL_VALIDATION_MSGS.required_field}</FormHelperText>}
          </ModalContent>
          <ModalActions>
            <Button onClick={onClose} variant="secondary">
              {labelBtnSecondary}
            </Button>
            <Button type={'submit'} variant={'primary'}>
              {labelBtnPrimary}
            </Button>
          </ModalActions>
          </form>
      </Modal>
}